/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:15
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-10 19:30:12
 * @FilePath: \ioc_base\src\modules\historyAlarm\lang\zh.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  // 模块名称
  historyAlarm: {
    // 按钮类
    button: {
      choose: "选择",
      Reset: "重置",
      Search: "查询",
      View: "查看",
      close: "关闭",
      confirm: "确定",
      export: "导出",
      cancel: "取消"
    },
    // 文字标签类
    label: {
      details: "详情",
      uploadVideo: "上传视频:",
      no: "暂无",
      reportTo: "上报人: ",
      warnDesc: "告警描述 ：",
      relatedDocuments: "相关文件:",
      exeNumber: "执行人编号",
      executive: "执行人员",
      implementation: "执行情况:",
      executiveAct: "执行动作：",
      executiveDes: "执行描述：",
      screening: "展开筛选",
      closeScreening: "收起筛选",
      wholeChexk: "全选",
      taskName: "任务名称",
      creatorName: "指派人",
      taskType: "任务类型",
      status: "任务状态",
      taskPriority: "优先级",
      taskVisibility: "可见性",
      createTime: "指派时间",
      desc: "详细描述",
      modifyTime: "实际完成时间",
      doDetail: "执行明细",
      alarmDetail: "告警明细",
      doStart: "要求开始时间",
      doEnd: "要求完成时间",
      whole: "全部",
      resShow: "资源展示",
      noData: "暂无数据",
      scan: "实时浏览",
      videoPlay: "录像回放",
      waiting: "初始化控件，请稍候...",
      play: "播放",
      snap: "抓拍",
      full: "全屏",
      playback: "录像回放",
      exporting: "正在导出"
    },
    // 提示类
    placeholder: {
      startDate: "开始日期",
      endDate: "结束日期"
    },
    // 消息类
    message: {
      unableView: "无法查看任务详情",
      noDeviceInfor: "当前告警无设备信息！",
      noDevicePlan: "设备无录像计划！",
      selArea: "请选择区域",
      export90: "导出数据时间跨度不可超过90天",
      alarmTime: "未输入告警时间,默认导出最近7天数据?"
    },
    // 标题类
    title: {
      alarmDetail: "告警详情",
      SnapshotPreview: "抓拍预览",
      alarmName: "告警名称:",
      alarmType: "告警类型",
      alarmLevel: "告警级别",
      alarmTime: "告警时间",
      alarmLoca: "告警位置:",
      videoPlayback: "录像回放:",
      dealWith: "处理详情",
      Processingpers: "处理人员 ：",
      ProcessingDes: "处理描述 ：",
      viewTask: "查看任务详情",
      taskDetail: "任务详情",
      resourcesDetail: "资源详情:",
      choose: "选择区域:",
      subsystem: "来源子系统",
      alarmState: "处理状态",
      area: "告警区域",
      deviceName: "告警设备",
      alarmArea: "区域",
      historyAlarm: "历史告警",
      prompt: "提示"
    }
  }
};
